import styled from 'styled-components'

const IconBasket = ({className}: {className?: string}) => {
  return (
    <Svg
      className={className}
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.34901 10.4815V4.55556C7.34901 3.61256 7.73363 2.70819 8.41828 2.0414C9.10292 1.3746 10.0315 1 10.9997 1C11.9679 1 12.8965 1.3746 13.5812 2.0414C14.2658 2.70819 14.6504 3.61256 14.6504 4.55556V10.4815M4.10109 6.92593H17.8996C18.2505 6.92589 18.5973 6.99975 18.9161 7.14246C19.235 7.28517 19.5184 7.49334 19.7469 7.75271C19.9754 8.01209 20.1436 8.31652 20.24 8.64514C20.3364 8.97376 20.3587 9.31879 20.3054 9.65659L18.7782 19.3182C18.6456 20.1579 18.2087 20.9235 17.5467 21.4766C16.8846 22.0297 16.0411 22.3336 15.1688 22.3333H6.83061C5.95857 22.3333 5.11536 22.0292 4.45354 21.4762C3.79173 20.9232 3.35504 20.1577 3.22249 19.3182L1.69527 9.65659C1.64193 9.31879 1.66423 8.97376 1.76063 8.64514C1.85703 8.31652 2.02525 8.01209 2.25376 7.75271C2.48228 7.49334 2.76568 7.28517 3.08454 7.14246C3.4034 6.99975 3.75018 6.92589 4.10109 6.92593Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}

const Svg = styled.svg``

export default IconBasket
